import React, { Component } from 'react'
import { Modal, Form, Button, Select, Input, Row, Col, Tag } from 'antd'
import { graphql, withApollo, Query } from 'react-apollo'
import _includes from 'lodash/includes'
import { inject } from 'mobx-react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router'
import _get from 'lodash/get'

import deliveryAddressQuery from '~/App/graphql/queries/deliveryAddress.gql'
import createDeliveryAddressMutation from '~/App/graphql/mutations/createDeliveryAddress.gql'
import updateDeliveryAddressMutation from '~/App/graphql/mutations/updateDeliveryAddress.gql'
import updateRegistrationDeliveryAddressMutation from '~/App/graphql/mutations/updateRegistrationDeliveryAddress.gql'
import statesQuery from '~/App/graphql/queries/states.gql'
import countries from '~/data/countries'
import localeGet from '~/App/utils/localeGet'
const inputCols = {
  labelCol: { sm: { span: 10 }, xs: { span: 24 } },
  wrapperCol: { sm: { span: 14 }, xs: { span: 24 } }
}
const ObgIdRegex = new RegExp('^[0-9a-fA-F]{24}$')
@Form.create()
@graphql(createDeliveryAddressMutation, { name: 'createDeliveryAddressMutation' })
@graphql(updateDeliveryAddressMutation, { name: 'updateDeliveryAddressMutation' })
@withRouter
@withApollo
@inject('i18n')
@injectIntl
@graphql(deliveryAddressQuery, {
  options: ({ dAddrId }) => ({
    variables: { _id: ObgIdRegex.test(dAddrId) ? dAddrId : '' },
    fetchPolicy: 'network-only'
  })
})
@graphql(updateRegistrationDeliveryAddressMutation, {
  name: 'updateRegistrationDeliveryAddressMutation'
})
class DeliveryAddressFormModal extends Component {
  submitting = false
  editMode = true
  componentDidMount () {
    const {dAddrId, dAddrIds, history, registration} = this.props
    if (dAddrId !== 'new' && _includes(dAddrIds, dAddrId)) {
      history.push(`/reg/${registration._id}/preview?dAddr=select&`)
    }
  }
  onClose = e => {
    const { registration, history } = this.props
    history.push(`/reg/${registration._id}/preview`)
  }
  alertError = (err) => {
    const { graphQLErrors } = err
    if (graphQLErrors) {
      graphQLErrors.forEach(error => {
        Modal.error({
          title: 'Error',
          content: error.message
        })
      })
    } else {
      Modal.error({
        title: 'Error',
        content: err.message
      })
    }
  }
  render () {
    const {
      form,
      dAddrId,
      createDeliveryAddressMutation,
      updateDeliveryAddressMutation,
      i18n: { locale },
      visible,
      intl,
      data,
      updateRegistrationDeliveryAddressMutation,
      customMessage
    } = this.props
    const {
      getFieldDecorator,
      validateFieldsAndScroll
    } = form

    const requiredFieldMessage = intl.formatMessage({
      id: 'app.requiredFieldMessage',
      defaultMessage: 'This field is required'
    })

    this.editMode = dAddrId !== 'new'
    const handleSubmit = e => {
      e.preventDefault()
      const { registration } = this.props
      validateFieldsAndScroll({ force: true }, (err, record) => {
        if (!err) {
          if (!this.submitting) {
            this.submitting = false
            if (this.editMode) {
              updateDeliveryAddressMutation({
                variables: {
                  record: {
                    ...record.deliveryAddress,
                    _id: dAddrId
                  }
                }
              }).then(res => {
                updateRegistrationDeliveryAddressMutation({
                  variables: {
                    record: {
                      _id: registration._id,
                      deliveryAddress: record.deliveryAddress
                    }
                  }
                }).then(res => {
                  this.props.history.push(
                    `/reg/${registration._id}/preview`
                  )
                }).catch(e => {
                  console.error({e})
                  this.alertError(e)
                  this.submitting = false
                })
              }).catch(e => {
                console.error({e})
                this.alertError(e)
                this.submitting = false
              })
            } else {
              createDeliveryAddressMutation({
                variables: { record: record.deliveryAddress }
              }).then(res => {
                updateRegistrationDeliveryAddressMutation({
                  variables: {
                    record: {
                      _id: registration._id,
                      deliveryAddress: record.deliveryAddress
                    }
                  }
                }).then(res => {
                  this.props.history.push(
                    `/reg/${registration._id}/preview`
                  )
                }).catch(e => {
                  this.alertError(e)
                  this.submitting = false
                })
              }).catch(e => {
                this.alertError(e)
                this.submitting = false
              })
            }
          }
        }
      })
    }
    return (
      <Modal
        className="responsiveModal"
        maskClosable={false}
        visible={visible}
        width={600}
        title={
          ({
            en: `Select deliver address`,
            zh: `Select deliver address`,
            th: `เลือกที่อยู่`
          })[locale]
        }
        onCancel={ !this.submitting ? this.onClose : () => {} }
        id="modal"
        footer={[
          <Button key="close" onClick={this.onClose} loading={this.submitting}>ยกเลิก</Button>,
          <Button key="submit" icon="mail" onClick={handleSubmit} loading={this.submitting} type="primary">
            <FormattedMessage id="app.deliverToThisAddress" />
          </Button>
        ]}
      >
        <div ref={ref => { this.modalRef = ref }} >
          {customMessage && <Tag color="orange" className="status">
            {customMessage}
          </Tag>}
          <div>
            <Form >
              <Row>
                <Col sm={{ span: 24 }}>
                  <Input.Group key={`deliveryAddress`}>
                    <Form.Item
                      label={{ en: 'Address number and street',zh: 'Address number and street', th: 'บ้านเลขที่ และ ถนน' }[locale]}
                      {...inputCols}
                    >
                      {getFieldDecorator(`deliveryAddress.street`, {
                        initialValue: _get(data, 'deliveryAddress.street'),
                        rules: [{ required: true,
                          message: requiredFieldMessage }]
                      })(
                        <Input.TextArea rows={2}/>
                      )}
                    </Form.Item>

                    <Form.Item
                      label={{ en: 'Locality',zh: 'Locality', th: 'ตำบล/แขวง' }[locale]}
                      {...inputCols}
                    >
                      {getFieldDecorator(`deliveryAddress.locality`, {
                        initialValue: _get(data, 'deliveryAddress.locality'),
                        rules: [{ required: true,
                          message: requiredFieldMessage }]
                      })(
                        <Input />
                      )}
                    </Form.Item>

                    <Form.Item
                      label={{ en: 'City',zh: 'City', th: 'อำเภอ/เขต' }[locale]}
                      {...inputCols}
                    >
                      {getFieldDecorator(`deliveryAddress.city`, {
                        initialValue: _get(data, 'deliveryAddress.city'),
                        rules: [{ required: true,
                          message: requiredFieldMessage }]
                      })(
                        <Input />
                      )}
                    </Form.Item>

                    <Query query={statesQuery} variables={{ countryName: 'Thailand' }}>
                      {(states) => {
                        const statesByCountry = _get(states, 'data.statesByCountry')
                        const loading = _get(states, 'loading')
                        if (loading) return <div>Loading...</div>
                        if (!statesByCountry) return <div>Data not found</div>
                        return <Form.Item
                          label={{ en: 'Province', th: 'จังหวัด' }[locale]}
                          {...inputCols}
                        >
                          {getFieldDecorator(`deliveryAddress.province`, {
                            initialValue: this.editMode ? _get(data, 'deliveryAddress.province') : '',
                            rules: [{ required: true,
                              message: requiredFieldMessage }]
                          })(
                            <Select
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .startsWith(input.toLowerCase())}
                            >
                              {statesByCountry.map(state =>
                                <Select.Option
                                  key={state._id}
                                  value={state._id}
                                >
                                  {localeGet(state, 'name', locale)}
                                </Select.Option>
                              )}
                            </Select>
                          )}
                        </Form.Item>
                      }}
                    </Query>
                    <Form.Item
                      label={{ en: 'Country',zh: 'Country', th: 'ประเทศ' }[locale]}
                      {...inputCols}
                    >
                      {getFieldDecorator(`deliveryAddress.country`, {
                        initialValue: _get(data, 'deliveryAddress.country') || 'Thailand',
                        rules: [{ required: true,
                          message: requiredFieldMessage }]
                      })(
                        <Select
                          showSearch
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .startsWith(input.toLowerCase())}
                        >
                          {countries.map(country =>
                            <Select.Option
                              key={country}
                              value={country}
                            >
                              {country}
                            </Select.Option>
                          )}
                        </Select>
                      )}
                    </Form.Item>

                    <Form.Item
                      label={{ en: 'Postal Code', zh: 'Postal Code', th: 'รหัสไปรษณีย์' }[locale]}
                      {...inputCols}
                    >
                      {getFieldDecorator(`deliveryAddress.postalCode`, {
                        initialValue: _get(data, 'deliveryAddress.postalCode'),
                        rules: [{ required: true,
                          message: requiredFieldMessage }]
                      })(
                        <Input />
                      )}
                    </Form.Item>

                    <Form.Item
                      label={{ en: 'Fullname', zh: 'Fullname', th: 'ชื่อ - สกุล' }[locale]}
                      {...inputCols}
                    >
                      {getFieldDecorator(`deliveryAddress.fullname`, {
                        initialValue: _get(data, 'deliveryAddress.fullname'),
                        rules: [{ required: true,
                          message: requiredFieldMessage }]
                      })(<Input key={`fullname`} />)}
                    </Form.Item>

                    <Form.Item
                      label={{ en: 'Telephone', zh: 'Telephone', th: 'โทรศัพท์' }[locale]}
                      {...inputCols}
                    >
                      {getFieldDecorator(`deliveryAddress.telephone`, {
                        initialValue: _get(data, 'deliveryAddress.telephone'),
                        rules: [
                          {
                            // pattern: /^[+][0-9]+?$|^[0-9]+?$/,
                            pattern: /^[0-9]{10,14}$/,
                            required: true,
                            message: intl.formatMessage({ id: 'app.incorrectPhone', defaultMessage: 'Please enter valid telephone number' })
                          }
                        ]
                      })(<Input key={`telephone`} />)}
                    </Form.Item>
                  </Input.Group>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Modal>
    )
  }
}
export default DeliveryAddressFormModal



// WEBPACK FOOTER //
// ./src/App/components/DeliveryAddressModal/DeliveryAddressFormModal.js